import { MinusPurpleIcon, PlusPurpleIcon } from "Assets/icons";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { useField, useFormikContext } from "formik";
import { dateFormat, stringToDate } from "helpers/common";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactSwitch from "react-switch";

const QuestionCounter = ({ question, fieldName }) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(fieldName);
    console.log("counter", field.value)
    const [checked, setChecked] = useState(true);
    useEffect(() => {
        setFieldValue(fieldName, {
            answer: field?.value?.answer ? parseInt(field?.value?.answer) : 0,
            other_details: { showCounter: true }
        })
    }, [])

    return (
        <>
            <Row>
                <Col md="6" className="my-2">
                    <div className="d-flex align-items-center gap-10">
                        <div className=" d-flex align-items-center mb-3">
                            <p className="m-0 text-muted mx-1">Off</p>
                            <ReactSwitch
                                uncheckedIcon={""}
                                checkedIcon={false}
                                onHandleColor={"#A3DF00"}
                                offHandleColor={"#A3DF00"}
                                onColor={"#E6E6E6"}
                                offColor={"#E6E6E6"}
                                height={18}
                                width={40}
                                onChange={(e) => {
                                    setChecked(e)
                                    setFieldValue(fieldName, { ...field?.value, other_details: { showCounter: e } })
                                }}
                                checked={checked}
                            />
                            <p className="m-0 text-muted mx-1">On</p>
                        </div>
                    </div>
                    {field.value?.other_details?.showCounter && <div className="d-flex align-items-center gap-10">
                        <Button className="border-0 p-0" variant="transparent">
                            <MinusPurpleIcon onClick={() => setFieldValue(fieldName, { ...field?.value, answer: field?.value?.answer ? parseInt(field?.value?.answer) - 1 : 0 })} />
                        </Button>
                        <h2 className="m-0 themeClr fw-bold px-2">{field?.value?.answer || 0}</h2>
                        <Button className="border-0 p-0" variant="transparent">
                            <PlusPurpleIcon onClick={() => setFieldValue(fieldName, { ...field?.value, answer: parseInt(field?.value?.answer || 0) + 1 })} />
                        </Button>
                    </div>}
                </Col>
            </Row>

            {meta?.touched && meta?.error?.other_details && (
                <div className="error">
                    Please enter counter
                </div>
            )}
        </>
    )
}

export default QuestionCounter;